export const URLS = {

    // Live
    baseApi: 'https://api.bad-kursmanager.de/apiv2/admin/',
    baseApiLecturer: 'https://api.bad-kursmanager.de/apiv2/lecturer/',
    stundenplanUrl: 'https://api.bad-kursmanager.de/stundenplan/index.html',

    // Staging
    // baseApi: 'https://api.akademio-digital.de/apiv2/admin/',
    // baseApiLecturer: 'https://api.akademio-digital.de/apiv2/lecturer/',
    // stundenplanUrl: 'https://api.akademio-digital.de/stundenplan/index.html',

    //  Local
    // baseApi: 'http://192.168.31.248:3000/apiv2/admin/',
    // baseApiLecturer: 'http://192.168.31.248:3000/apiv2/lecturer/',
    // stundenplanUrl: 'http://192.168.31.248:3000/stundenplan/index.html',
}